// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Settings Page Styles */

.settings-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.settings-category-accordion {
  margin-bottom: 16px;
}

.settings-category-title {
  font-weight: 600;
  font-size: 1.1rem;
}

.settings-input-group {
  margin-bottom: 24px;
}

.settings-chips-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/System/Settings/Settings.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB","sourcesContent":["/* Settings Page Styles */\n\n.settings-container {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.settings-category-accordion {\n  margin-bottom: 16px;\n}\n\n.settings-category-title {\n  font-weight: 600;\n  font-size: 1.1rem;\n}\n\n.settings-input-group {\n  margin-bottom: 24px;\n}\n\n.settings-chips-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
